import React from 'react';
import LocationTemplate from './LocationTemplate';

const BensonPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Benson"
      stateName="North Carolina"
      countyName="Johnston"
      zipCodes={["27504"]}
      latitude={35.3827}
      longitude={-78.5475}
      population={3967}
      historicalFact="Originally called Benson's Crossroads, known for the annual Mule Days festival since 1949."
      nearbyTowns={[
        "Smithfield, NC",
        "Dunn, NC",
        "Four Oaks, NC",
        "Clayton, NC",
        "Selma, NC",
        "Angier, NC",
        "Newton Grove, NC",
        "Garner, NC"
      ]}
    />
  );
};

export default BensonPage;